import { useState } from "react";

export type SubscoresState = {
    setSubscores: (subscores: boolean | undefined) => void;
};

type SubscoresParams = {
    query: boolean | undefined;
    state: SubscoresState;
};
export const useSubscores = (initSubscores?: boolean): SubscoresParams => {
    const [subscores, setSubscores] = useState<boolean | undefined>(initSubscores);

    return {
        query: subscores,
        state: {
            setSubscores,
        },
    };
};
